module.exports = __webpack_public_path__ + "static/img/image_tabar_followers@3x.fb578dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/image_tabar_followers@3x.png
// module id = 249
// module chunks = 18